export const prefectureOptionList = [
  { label: '東京', value: '東京' },
  { label: '大阪', value: '大阪' },
  { label: '神奈川', value: '神奈川' },
  { label: '愛知', value: '愛知' },
  { label: '福岡', value: '福岡' },
  { label: 'その他', value: 'その他' },
]

export const tokyoRegionOptionList = [
  { label: '23区内', value: '23区内' },
  { label: 'それ以外', value: 'それ以外' },
]

export const regionOptionList = [{ label: '全て', value: '全て' }]

export const capacityOptionList = [
  { label: '定員10名', value: '定員10名' },
  { label: '定員30名', value: '定員30名' },
  { label: '定員50名', value: '定員50名' },
]

export const priceList = {
  東京: {
    '23区内': {
      定員10名: '¥210,000',
      定員30名: '¥230,000',
      定員50名: '¥300,000',
    },
    それ以外: {
      定員10名: '¥54,000',
      定員30名: '¥110,000',
      定員50名: '¥110,000',
    },
  },
  大阪: {
    全て: {
      定員10名: '¥110,000',
      定員30名: '¥180,000',
      定員50名: '¥170,000',
    },
  },
  神奈川: {
    全て: {
      定員10名: '¥180,000',
      定員30名: '¥110,000',
      定員50名: '¥190,000',
    },
  },
  愛知: {
    全て: {
      定員10名: '¥90,000',
      定員30名: '¥70,000',
      定員50名: '¥100,000',
    },
  },
  福岡: {
    全て: {
      定員10名: '¥70,000',
      定員30名: '¥80,000',
      定員50名: '¥60,000',
    },
  },
  その他: {
    全て: {
      定員10名: '¥40,000',
      定員30名: '¥50,000',
      定員50名: '¥40,000',
    },
  },
}
